// <div class="avatar" data-name="Jane Doe"></div>
document.querySelectorAll('.avatar[data-name]').forEach(el => {
    if (el.querySelector('img')) return;
    const name = el.getAttribute('data-name') || '';
    const initials = name.trim().split(/\s+/).slice(0,2).map(s=>s[0]?.toUpperCase()||'').join('');
    el.textContent = initials || '👤';
    // Couleur pseudo-aléatoire stable
    let h = 0; for (let i=0;i<name.length;i++) h = (h*31 + name.charCodeAt(i)) % 360;
    el.style.background = `hsl(${h} 70% 45%)`;
});
